import { spaceMetaSchema } from "./space-meta.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-create-response.ts
const createSpaceResponseSchema = z$1.strictObject({
	spaceId: spaceMetaSchema.shape.spaceId,
	meta: spaceMetaSchema.optional()
});
//#endregion
export { createSpaceResponseSchema };

//# sourceMappingURL=space-create-response.js.map